export interface ElementLocaleData {
  name: string;
  description: string;
  uses: string;
}

export const elementsEn: Record<number, ElementLocaleData> = {
  1: {
    name: 'Hydrogen',
    description: 'Hydrogen is the lightest and most abundant chemical element in the universe.',
    uses: 'Ammonia production, oil refining, rocket fuel.',
  },
  2: {
    name: 'Helium',
    description: 'Helium is an inert noble gas and the second most abundant element in the universe.',
    uses: 'Balloons, airships, cooling superconducting magnets.',
  },
  3: {
    name: 'Lithium',
    description: 'Lithium is the lightest solid metal and has exceptional energy storage capacity.',
    uses: 'Lithium-ion batteries, medications, lightweight alloys, glass and ceramics.',
  },
  4: {
    name: 'Beryllium',
    description: 'Beryllium is a lightweight alkaline earth metal, relatively rare in the Earth\'s crust.',
    uses: 'Aerospace alloys, neutron moderator in nuclear reactors, X-rays.',
  },
  5: {
    name: 'Boron',
    description: 'Boron is a metalloid that forms compounds similar to carbon but with a variety of structures.',
    uses: 'Borosilicate glass, detergents, semiconductors, agriculture.',
  },
  6: {
    name: 'Carbon',
    description: 'Carbon is a non-metallic element that forms the basis of organic chemistry.',
    uses: 'Steel, plastics, nanotubes, diamonds, carbon fiber.',
  },
  7: {
    name: 'Nitrogen',
    description: 'Nitrogen makes up about 78% of Earth\'s atmosphere.',
    uses: 'Fertilizers, explosives, refrigeration, nitric acid production.',
  },
  8: {
    name: 'Oxygen',
    description: 'Oxygen is essential for respiration and combustion.',
    uses: 'Medicine, steel production, water treatment, rocket propellant.',
  },
  9: {
    name: 'Fluorine',
    description: 'Fluorine is the most electronegative and reactive element in the periodic table.',
    uses: 'Uranium production, refrigerants, toothpaste, polymers such as Teflon.',
  },
  10: {
    name: 'Neon',
    description: 'Neon is a colorless, odorless, inert noble gas that emits a red-orange glow when electrified.',
    uses: 'Neon signs, lasers, cryogenic refrigeration, televisions.',
  },
  11: {
    name: 'Sodium',
    description: 'Sodium is a highly reactive alkali metal and the sixth most abundant element in the Earth\'s crust.',
    uses: 'Soda production, sodium vapor lamps, coolant in nuclear reactors.',
  },
  12: {
    name: 'Magnesium',
    description: 'Magnesium is a lightweight silvery-white alkaline earth metal, the eighth most abundant element in the Earth\'s crust.',
    uses: 'Lightweight alloys, fireworks, dietary supplement, chemical reduction.',
  },
  13: {
    name: 'Aluminium',
    description: 'Aluminium is a lightweight, non-magnetic, corrosion-resistant metal and the most abundant metal in the Earth\'s crust.',
    uses: 'Construction, packaging, transportation, electronics.',
  },
  14: {
    name: 'Silicon',
    description: 'Silicon is a semiconducting metalloid that forms the basis of modern microelectronics.',
    uses: 'Semiconductors, solar cells, glass, ceramics, silicones.',
  },
  15: {
    name: 'Phosphorus',
    description: 'Phosphorus is a non-metallic element essential for life, existing in several allotropes.',
    uses: 'Fertilizers, matches, detergents, food additives, nucleic acids (DNA, RNA).',
  },
  16: {
    name: 'Sulfur',
    description: 'Sulfur is a yellow non-metallic element known since antiquity that plays an important role in many biological processes.',
    uses: 'Sulfuric acid production, gunpowder, rubber vulcanization, fungicide.',
  },
  17: {
    name: 'Chlorine',
    description: 'Chlorine is a yellow-green halogen used as a disinfectant.',
    uses: 'Water disinfection, chemical manufacturing, PVC plastics.',
  },
  18: {
    name: 'Argon',
    description: 'Argon is an inert noble gas making up about 1% of Earth\'s atmosphere.',
    uses: 'Protective atmosphere for welding, light bulbs, window insulation, non-reactive nitrogen substitute.',
  },
  19: {
    name: 'Potassium',
    description: 'Potassium is a highly reactive alkali metal and the eighth most abundant element in the Earth\'s crust.',
    uses: 'Fertilizers, soap production, food processing, glass manufacturing.',
  },
  20: {
    name: 'Calcium',
    description: 'Calcium is a silvery-grey alkaline earth metal, the fifth most abundant element in the Earth\'s crust, essential for life.',
    uses: 'Construction (cement, plaster), nutritional supplements, reducing agent.',
  },
  21: {
    name: 'Scandium',
    description: 'Scandium is a lightweight silvery transition metal.',
    uses: 'Aluminum alloys for aerospace, metal-halide lamps.',
  },
  22: {
    name: 'Titanium',
    description: 'Titanium is a strong, lightweight and corrosion-resistant transition metal.',
    uses: 'Aerospace, medical implants, pigments, alloys.',
  },
  23: {
    name: 'Vanadium',
    description: 'Vanadium is used primarily to improve the properties of steel.',
    uses: 'Steel alloys, catalysts, redox flow batteries.',
  },
  24: {
    name: 'Chromium',
    description: 'Chromium is a hard, lustrous and corrosion-resistant metal.',
    uses: 'Stainless steel, chrome plating, pigments, leather tanning.',
  },
  25: {
    name: 'Manganese',
    description: 'Manganese is essential for steel production and plays an important role in biological systems.',
    uses: 'Steel production, dry cell batteries, aluminum alloys.',
  },
  26: {
    name: 'Iron',
    description: 'Iron is an abundant and essential transition metal that has been crucial to the development of human civilization.',
    uses: 'Steel, construction, machinery, transportation, catalysts.',
  },
  27: {
    name: 'Cobalt',
    description: 'Cobalt is a hard, lustrous transition metal used in alloys and pigments.',
    uses: 'Lithium-ion batteries, high-temperature alloys, blue pigments.',
  },
  28: {
    name: 'Nickel',
    description: 'Nickel is a corrosion-resistant metal used in alloys.',
    uses: 'Stainless steel, coins, batteries, electroplating.',
  },
  29: {
    name: 'Copper',
    description: 'Copper is one of the first metals exploited by humans.',
    uses: 'Electrical wiring, plumbing, coins, alloys.',
  },
  30: {
    name: 'Zinc',
    description: 'Zinc is a bluish metal used for galvanization.',
    uses: 'Galvanization, alloys (brass), batteries, nutritional supplement.',
  },
  31: {
    name: 'Gallium',
    description: 'Gallium melts in the hand and is used in electronics.',
    uses: 'Semiconductors, LEDs, solar cells, thermometers.',
  },
  32: {
    name: 'Germanium',
    description: 'Germanium is a metalloid used in electronics.',
    uses: 'Transistors, infrared detectors, fiber optics.',
  },
  33: {
    name: 'Arsenic',
    description: 'Arsenic is toxic but used in certain alloys.',
    uses: 'Lead alloys, pesticides, semiconductors.',
  },
  34: {
    name: 'Selenium',
    description: 'Selenium is an essential trace element.',
    uses: 'Photocopiers, solar cells, colored glass, nutritional supplement.',
  },
  35: {
    name: 'Bromine',
    description: 'Bromine is the only non-metallic element that is liquid at room temperature.',
    uses: 'Flame retardants, pool disinfection, photography.',
  },
  36: {
    name: 'Krypton',
    description: 'Krypton is a noble gas used in lighting.',
    uses: 'Lighting, lasers, window insulation.',
  },
  37: {
    name: 'Rubidium',
    description: 'Rubidium is a highly reactive alkali metal.',
    uses: 'Atomic clocks, catalysts, biomedical research.',
  },
  38: {
    name: 'Strontium',
    description: 'Strontium produces a brilliant red flame.',
    uses: 'Fireworks, cathode ray tubes, ferrite magnets.',
  },
  39: {
    name: 'Yttrium',
    description: 'Yttrium is used in superconductors and LEDs.',
    uses: 'Superconductors, LEDs, lasers, alloys.',
  },
  40: {
    name: 'Zirconium',
    description: 'Zirconium is corrosion-resistant and used in nuclear reactors.',
    uses: 'Nuclear reactors, ceramics, jewelry, dental implants.',
  },
  41: {
    name: 'Niobium',
    description: 'Niobium is used in superconductors and alloys.',
    uses: 'Superconductors, specialty steels, jewelry.',
  },
  42: {
    name: 'Molybdenum',
    description: 'Molybdenum has a high melting point and is used in alloys.',
    uses: 'High-strength steels, catalysts, lubricants.',
  },
  43: {
    name: 'Technetium',
    description: 'Technetium is the first synthetic element to be discovered.',
    uses: 'Medical imaging, corrosion inhibitor.',
  },
  44: {
    name: 'Ruthenium',
    description: 'Ruthenium is a rare and resistant platinum-group metal.',
    uses: 'Catalysts, electrical contacts, platinum hardening.',
  },
  45: {
    name: 'Rhodium',
    description: 'Rhodium is a precious metal used in catalysis.',
    uses: 'Automotive catalytic converters, jewelry, mirrors.',
  },
  46: {
    name: 'Palladium',
    description: 'Palladium can absorb large quantities of hydrogen.',
    uses: 'Catalysts, electronics, jewelry, dentistry.',
  },
  47: {
    name: 'Silver',
    description: 'Silver is known for its electrical conductivity and corrosion resistance.',
    uses: 'Jewelry, photography, electronics, currency.',
  },
  48: {
    name: 'Cadmium',
    description: 'Cadmium is toxic and used in batteries.',
    uses: 'Ni-Cd batteries, pigments, electroplating, PVC stabilizers.',
  },
  49: {
    name: 'Indium',
    description: 'Indium is soft and used in touchscreens.',
    uses: 'LCD screens, alloys, semiconductors, soldering.',
  },
  50: {
    name: 'Tin',
    description: 'Tin is used to protect other metals from corrosion.',
    uses: 'Tin plating, solder, bronze alloys, food cans.',
  },
  51: {
    name: 'Antimony',
    description: 'Antimony is a metalloid used in flame retardants.',
    uses: 'Flame retardants, lead alloys, semiconductors.',
  },
  52: {
    name: 'Tellurium',
    description: 'Tellurium is rare and used in metallurgy.',
    uses: 'Solar cells, thermoelectrics, steel alloys.',
  },
  53: {
    name: 'Iodine',
    description: 'Iodine is essential for the human thyroid gland.',
    uses: 'Antiseptics, nutritional supplements, photography, organic synthesis.',
  },
  54: {
    name: 'Xenon',
    description: 'Xenon is used in lamps and anesthesia.',
    uses: 'High-intensity lamps, anesthesia, ion propulsion systems.',
  },
  55: {
    name: 'Caesium',
    description: 'Caesium is the most reactive of the alkali metals.',
    uses: 'Atomic clocks, ion propulsion, photoelectric cells.',
  },
  56: {
    name: 'Barium',
    description: 'Barium is used in X-rays and fireworks.',
    uses: 'Medical X-ray contrast agents, fireworks, drilling fluids.',
  },
  57: {
    name: 'Lanthanum',
    description: 'Lanthanum is the first of the lanthanides.',
    uses: 'Camera lenses, hydrogen storage alloys, catalysts.',
  },
  58: {
    name: 'Cerium',
    description: 'Cerium is the most abundant of the rare earth elements.',
    uses: 'Catalytic converters, glass polishing, lighter flints.',
  },
  59: {
    name: 'Praseodymium',
    description: 'Praseodymium is used for welder\'s goggles.',
    uses: 'Welder\'s goggles, permanent magnets, aircraft engines.',
  },
  60: {
    name: 'Neodymium',
    description: 'Neodymium creates the most powerful permanent magnets.',
    uses: 'Powerful permanent magnets, lasers, headphones, wind turbines.',
  },
  61: {
    name: 'Promethium',
    description: 'Promethium is radioactive and does not occur naturally.',
    uses: 'Nuclear batteries, luminescent paint, thickness gauges.',
  },
  62: {
    name: 'Samarium',
    description: 'Samarium is used in magnets and lasers.',
    uses: 'Permanent magnets, lasers, cancer treatment.',
  },
  63: {
    name: 'Europium',
    description: 'Europium is used as a red phosphor in screens.',
    uses: 'Red phosphors in screens, anti-counterfeiting in banknotes, LEDs.',
  },
  64: {
    name: 'Gadolinium',
    description: 'Gadolinium has exceptional magnetic properties.',
    uses: 'MRI contrast agents, neutron capture, data storage.',
  },
  65: {
    name: 'Terbium',
    description: 'Terbium is used in green phosphors.',
    uses: 'Green phosphors, solid-state devices, alloys.',
  },
  66: {
    name: 'Dysprosium',
    description: 'Dysprosium is used in high-temperature magnets.',
    uses: 'High-temperature magnets, nuclear reactors, lasers.',
  },
  67: {
    name: 'Holmium',
    description: 'Holmium has the highest magnetic moment of any element.',
    uses: 'Magnets, lasers, nuclear reactors.',
  },
  68: {
    name: 'Erbium',
    description: 'Erbium is used in fiber-optic amplifiers.',
    uses: 'Fiber-optic amplifiers, lasers, glass coloring.',
  },
  69: {
    name: 'Thulium',
    description: 'Thulium is the least abundant of the rare earth elements.',
    uses: 'Portable X-ray devices, lasers, high-temperature superconductors.',
  },
  70: {
    name: 'Ytterbium',
    description: 'Ytterbium is used in atomic clocks.',
    uses: 'Atomic clocks, lasers, stainless steel alloys.',
  },
  71: {
    name: 'Lutetium',
    description: 'Lutetium is the last of the lanthanides.',
    uses: 'PET scan detectors, catalysts, alloys.',
  },
  72: {
    name: 'Hafnium',
    description: 'Hafnium absorbs neutrons and is used in reactors.',
    uses: 'Nuclear reactor control rods, microchip gate insulators, alloys.',
  },
  73: {
    name: 'Tantalum',
    description: 'Tantalum is extremely corrosion-resistant.',
    uses: 'Capacitors, surgical implants, chemical equipment.',
  },
  74: {
    name: 'Tungsten',
    description: 'Tungsten has the highest melting point of all metals.',
    uses: 'Light bulb filaments, cutting tools, armor-piercing projectiles.',
  },
  75: {
    name: 'Rhenium',
    description: 'Rhenium is a rare metal with a very high melting point.',
    uses: 'Jet engine superalloys, catalysts, thermocouples.',
  },
  76: {
    name: 'Osmium',
    description: 'Osmium is the densest naturally occurring element.',
    uses: 'Fountain pen tips, electrical contacts, alloys.',
  },
  77: {
    name: 'Iridium',
    description: 'Iridium is extremely corrosion-resistant.',
    uses: 'Spark plugs, crucibles, international prototype kilogram alloy.',
  },
  78: {
    name: 'Platinum',
    description: 'Platinum is a precious metal used in catalysis.',
    uses: 'Catalytic converters, jewelry, laboratory equipment, cancer drugs.',
  },
  79: {
    name: 'Gold',
    description: 'Gold is a dense, soft, malleable and ductile precious metal with a brilliant yellow color.',
    uses: 'Jewelry, electronics, monetary reserves, dentistry.',
  },
  80: {
    name: 'Mercury',
    description: 'Mercury is the only metal that is liquid at room temperature.',
    uses: 'Thermometers, fluorescent lamps, gold extraction, electrical switches.',
  },
  81: {
    name: 'Thallium',
    description: 'Thallium is toxic and used in electronics.',
    uses: 'Infrared detectors, semiconductors, cardiac imaging.',
  },
  82: {
    name: 'Lead',
    description: 'Lead is a heavy metal used in batteries.',
    uses: 'Lead-acid batteries, radiation shielding, plumbing, ammunition.',
  },
  83: {
    name: 'Bismuth',
    description: 'Bismuth has colorful crystals and is low in toxicity.',
    uses: 'Pharmaceuticals (Pepto-Bismol), cosmetics, fire sprinklers, alloys.',
  },
  84: {
    name: 'Polonium',
    description: 'Polonium is highly radioactive and dangerous.',
    uses: 'Anti-static devices, nuclear batteries, research.',
  },
  85: {
    name: 'Astatine',
    description: 'Astatine is the heaviest halogen and highly radioactive.',
    uses: 'Cancer radiotherapy research.',
  },
  86: {
    name: 'Radon',
    description: 'Radon is a radioactive noble gas and a carcinogen.',
    uses: 'Radiotherapy, earthquake prediction research.',
  },
  87: {
    name: 'Francium',
    description: 'Francium is the heaviest alkali metal and extremely rare.',
    uses: 'Scientific research, atomic structure studies.',
  },
  88: {
    name: 'Radium',
    description: 'Radium is highly radioactive and luminescent.',
    uses: 'Historical cancer treatment, luminescent paint, research.',
  },
  89: {
    name: 'Actinium',
    description: 'Actinium is the first of the actinides and is radioactive.',
    uses: 'Cancer treatment, neutron source, scientific research.',
  },
  90: {
    name: 'Thorium',
    description: 'Thorium is a potential source of nuclear energy.',
    uses: 'Nuclear fuel research, gas mantles, high-temperature alloys.',
  },
  91: {
    name: 'Protactinium',
    description: 'Protactinium is a precursor to uranium.',
    uses: 'Scientific research, geological dating.',
  },
  92: {
    name: 'Uranium',
    description: 'Uranium is used as nuclear fuel.',
    uses: 'Nuclear power plants, nuclear weapons, radiation shielding.',
  },
  93: {
    name: 'Neptunium',
    description: 'Neptunium is the first transuranium element to be synthesized.',
    uses: 'Neutron detection, plutonium-238 production.',
  },
  94: {
    name: 'Plutonium',
    description: 'Plutonium is used in nuclear weapons and reactors.',
    uses: 'Nuclear weapons, space probe power sources (RTGs), reactor fuel.',
  },
  95: {
    name: 'Americium',
    description: 'Americium is used in smoke detectors.',
    uses: 'Smoke detectors, industrial gauges, medical research.',
  },
  96: {
    name: 'Curium',
    description: 'Curium is named after Marie and Pierre Curie.',
    uses: 'Alpha particle sources, space exploration power, research.',
  },
  97: {
    name: 'Berkelium',
    description: 'Berkelium is named after Berkeley, California.',
    uses: 'Scientific research, synthesis of heavier elements.',
  },
  98: {
    name: 'Californium',
    description: 'Californium emits powerful neutron sources.',
    uses: 'Neutron source for starting nuclear reactors, oil well logging, cancer treatment.',
  },
  99: {
    name: 'Einsteinium',
    description: 'Einsteinium was discovered in the debris of nuclear tests.',
    uses: 'Scientific research, synthesis of heavier elements.',
  },
  100: {
    name: 'Fermium',
    description: 'Fermium is named after Enrico Fermi.',
    uses: 'Scientific research only.',
  },
  101: {
    name: 'Mendelevium',
    description: 'Mendelevium is named after Dmitri Mendeleev.',
    uses: 'Scientific research only.',
  },
  102: {
    name: 'Nobelium',
    description: 'Nobelium is named after Alfred Nobel.',
    uses: 'Scientific research only.',
  },
  103: {
    name: 'Lawrencium',
    description: 'Lawrencium is the last of the actinides.',
    uses: 'Scientific research only.',
  },
  104: {
    name: 'Rutherfordium',
    description: 'Rutherfordium is named after Ernest Rutherford.',
    uses: 'Scientific research only.',
  },
  105: {
    name: 'Dubnium',
    description: 'Dubnium is named after Dubna, Russia.',
    uses: 'Scientific research only.',
  },
  106: {
    name: 'Seaborgium',
    description: 'Seaborgium is named after Glenn T. Seaborg.',
    uses: 'Scientific research only.',
  },
  107: {
    name: 'Bohrium',
    description: 'Bohrium is named after Niels Bohr.',
    uses: 'Scientific research only.',
  },
  108: {
    name: 'Hassium',
    description: 'Hassium is named after Hesse, Germany.',
    uses: 'Scientific research only.',
  },
  109: {
    name: 'Meitnerium',
    description: 'Meitnerium is named after Lise Meitner.',
    uses: 'Scientific research only.',
  },
  110: {
    name: 'Darmstadtium',
    description: 'Darmstadtium is named after Darmstadt, Germany.',
    uses: 'Scientific research only.',
  },
  111: {
    name: 'Roentgenium',
    description: 'Roentgenium is named after Wilhelm Röntgen.',
    uses: 'Scientific research only.',
  },
  112: {
    name: 'Copernicium',
    description: 'Copernicium is named after Nicolaus Copernicus.',
    uses: 'Scientific research only.',
  },
  113: {
    name: 'Nihonium',
    description: 'Nihonium is named after Japan (Nihon).',
    uses: 'Scientific research only.',
  },
  114: {
    name: 'Flerovium',
    description: 'Flerovium is named after Georgiy Flyorov.',
    uses: 'Scientific research only.',
  },
  115: {
    name: 'Moscovium',
    description: 'Moscovium is named after Moscow.',
    uses: 'Scientific research only.',
  },
  116: {
    name: 'Livermorium',
    description: 'Livermorium is named after Livermore, California.',
    uses: 'Scientific research only.',
  },
  117: {
    name: 'Tennessine',
    description: 'Tennessine is named after Tennessee.',
    uses: 'Scientific research only.',
  },
  118: {
    name: 'Oganesson',
    description: 'Oganesson is named after Yuri Oganessian and completes the periodic table.',
    uses: 'Scientific research only.',
  },
};

export function getLocalizedElementData(
  atomicNumber: number,
  locale: string
): ElementLocaleData | null {
  if (locale === 'en') {
    return elementsEn[atomicNumber] ?? null;
  }
  return null;
}

export function translateHalfLife(halfLife: string, locale: string): string {
  if (locale !== 'en') return halfLife;
  return halfLife
    .replace(/millions? d'années/gi, 'million years')
    .replace(/\bans\b/gi, 'y')
    .replace(/\bjours?\b/gi, 'd')
    .replace(/\bsecondes?\b/gi, 's')
    .replace(/\bheures?\b/gi, 'h');
}
